import { Button } from '@mui/material';
import React from 'react';
import type { RegistryDealSetup } from '../../api/registryDealTypes';
import { SectionCard } from '../../ui/primitives';
import LogoDropZone from '../settings/LogoDropZone';

interface Props {
  setup: RegistryDealSetup;
  readOnly: boolean;
  busy: boolean;
  upload: (file: File) => void;
  useDefault: () => void;
}

/**
 * The fund's logo on the Branding step. A fund starts with the default logo from Default Values;
 * uploading here replaces it for this fund only, and "Use the default logo" goes back to it.
 */
export default function SetupLogoCard({ setup, readOnly, busy, upload, useDefault }: Props) {
  const ownLogo = Boolean(setup.values['brand.logoUrl']);
  const editable = !readOnly && setup.status === 'DRAFT';
  const note = ownLogo
    ? "This fund's own logo. The default logo is unchanged."
    : setup.logoUrl
      ? 'The default logo, from Default Values. Upload one to use a different logo for this fund only.'
      : 'No default logo yet. Upload one here for this fund, or set a default in Default Values.';
  return (
    <SectionCard title="Logo" subtitle={note}>
      <LogoDropZone
        logoFile={setup.logoUrl}
        busy={busy}
        editable={editable}
        onUpload={upload}
        showTitle={false}
        readOnlyText={setup.logoUrl ? 'Logo for this fund' : 'No logo'}
      />
      {editable && ownLogo && (
        <Button size="small" sx={{ mt: 1 }} disabled={busy} onClick={useDefault}>
          Use the default logo
        </Button>
      )}
    </SectionCard>
  );
}
